import React, { useState } from "react";
import { Input, Button, message } from "antd";
import { useDispatch } from "react-redux";
import { adminSetting } from "../../../redux/actions/authActions";

const { Password } = Input;

const SettingsHome = () => {
  const dispatch = useDispatch();

  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [loading, setLoading] = useState(false);//eslint-disable-next-line
  const [clients, setClients] = useState([]);


  const handleChangePassword = async () => {
    if (!currentPassword || !newPassword) {
      message.error("Both fields are required");
      return;
    }

    setLoading(true);

    try {
      await dispatch(adminSetting(currentPassword, newPassword));
      message.success("Password updated successfully");

      setCurrentPassword("");
      setNewPassword("");
    } catch (errorMsg) {
      message.error(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-sm mt-4">
      <h2 className="text-xl font-bold mb-6">Reset Password</h2>

      <div className="mb-4">
        <label className="block mb-2 font-medium text-gray-700">
          Enter Current Password
        </label>
        <Password
          placeholder="Enter current password"
          className="w-full"
          value={currentPassword}
          onChange={(e) => setCurrentPassword(e.target.value)}
        />
      </div>

      <div className="mb-6">
        <label className="block mb-2 font-medium text-gray-700">
          Enter New Password
        </label>
        <Password
          placeholder="Enter new password"
          className="w-full"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
        />
      </div>

      <Button
        type="primary"
        loading={loading}
        onClick={handleChangePassword}
        className="w-full rounded-full bg-[#045B9B] hover:bg-blue-800 text-white !py-5 text-base"
      >
        Save Changes
      </Button>
    </div>
  );
};

export default SettingsHome;
